import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ComingSoon from '@app/components/presentational/ComingSoon';
import HomePage from './HomePage';
import PostDetailMobileScreen from './widgets/RecentUpdates/PostDetailMobileScreen';
import UpcomingAssignmentsMobileScreen from './widgets/upcomingAssignmentsWidget/UpcomingAssignmentsMobileScreen';
import { useMediaQuery, useTheme } from '@ublend-npm/aulaui-core';
import { useSelector } from 'react-redux';
import { location as getLocation } from '@app/selectors/routing';
import ConversationPageView from './widgets/messagesWidget/ConversationPageView';
import AllConversationsPageView from './widgets/messagesWidget/AllConversationsPageView';
import OutlookAllEmailsMobileScreen from './widgets/outlookWidget/OutlookAllEmailsMobileScreen';
import OutlookThreadMobileScreen from './widgets/outlookWidget/OutlookThreadMobileScreen';

const HomeToggle = () => {
  const { webAppFtHomePageEnableFlag202605 } = useFlags();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const pathname = useSelector(getLocation)?.pathname ?? '';
  const match = pathname.match(/\/home\/post\/(.+)/);
  const routePostId = match ? match[1] : null;
  const isUpcomingAssignmentsRoute = pathname === '/home/upcoming-assignments';
  const conversationRoute = pathname.includes('/home/messages');
  const allConversationsRoute = pathname === '/home/all-conversations';
  const isAllEmailsRoute = pathname === '/home/all-emails';
  const emailMatch = pathname.match(/\/home\/email\/(.+)/);
  const routeEmailId = emailMatch ? emailMatch[1] : null;

  if (webAppFtHomePageEnableFlag202605) {
    if (routePostId && isSmallScreen) {
      return <PostDetailMobileScreen routePostId={routePostId} />;
    } else if (isUpcomingAssignmentsRoute && isSmallScreen) {
      return <UpcomingAssignmentsMobileScreen />;
    } else if (conversationRoute && isSmallScreen) {
      return <ConversationPageView />;
    } else if (allConversationsRoute && isSmallScreen) {
      return <AllConversationsPageView />;
    } else if (routeEmailId && isSmallScreen) {
      return <OutlookThreadMobileScreen routeEmailId={routeEmailId} />;
    } else if (isAllEmailsRoute && isSmallScreen) {
      return <OutlookAllEmailsMobileScreen />;
    }
    return <HomePage />;
  }

  return <ComingSoon />;
};

export default HomeToggle;
